import { useSelector } from 'react-redux'
import { AlertTemplate } from '../types/Alerts'
import { RootState } from '../redux'

export default function useDeviceAlertTemplates(): AlertTemplate[] {
  return useSelector((state: RootState) => state.devices.alertTemplates)
}
